/* eslint-disable no-console */
export const getIntPart = (num: number): string => Math.trunc(num).toString()
export const getDecimalPart = (num: number): string => {
  const decimal = (num + '').split('.')[1]
  return decimal ? (decimal.length === 1 ? decimal + '0' : decimal) : '00'
}
export const isDigit = (num: number | string): boolean => !isNaN(Number(num))
export const addCommaToNumber = (num: number, toFixed = 2): string => num.toFixed(toFixed).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
export const addCommaToOrderNumber = (num: number): string => num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
